export function changeDimensions(width, height) {
  return {
    type: 'CHANGE_DIMENSIONS',
    width,
    height,
  };
}
